import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import theme from '../../../booking-system/appointment-booking/src/styles/theme';

const useCalendarStyles = () => {
  const { makeStyles } = useUiContext();

  const slotStyle = {
    fontSize: 24,
    fontWeight: 600,
    width: '100%',
    padding: 0,
    margin: '1px 0',
    cursor: 'pointer',
    position: 'relative',
    display: 'grid',
    maxHeight: 66,
    minHeight: 66,
  };

  const sliderStyle = {
    top: 20,
    left: 0,
    content: '',
    position: 'absolute',
    width: 30,
    height: 30,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    cursor: 'pointer',
    zIndex: 2,
    '@media only screen and (min-width: 1025px)': {
      left: -50,
    },
    '@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
      top: 100,
    },
  };

  const useStyles = makeStyles({
    calendarContainer: {
      overflow: 'hidden',
    },
    calendarColumnHeader: {
      padding: '6px 0',
      display: 'inline-block',
      width: '100%',
      backgroundColor: '#e2e6e5',
      position: 'sticky',
      top: 0,
      zIndex: 1,
      textAlign: 'center',
      marginTop: 11,
      paddingTop: 15,

      '@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        paddingTop: '3em',
      },
    },
    calendarColumnHeaderMonth: {
      fontFamily: 'apercu-medium-pro',
      color: '#8a9b97',
      fontSize: 18,
      fontWeight: 800,
      textTransform: 'uppercase',
      display: 'block',
      margin: '15px 0',
    },
    calendarColumnHeaderDay: {
      fontFamily: 'apercu-medium-pro',
      color: '#01372c',
      fontSize: 15,
      fontWeight: 800,
      textTransform: 'uppercase',
      display: 'block',

      '@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)': {
        paddingTop: 45,
      },
    },
    calendarColumnHeaderDate: {
      color: '#8a9b97',
      fontSize: 12,
      fontWeight: 600,
      display: 'block',
    },
    calendarColumnToday: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      height: 'auto',
      flex: 1,
      backgroundColor: '#0b372c2b',
    },
    calendarColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      height: 'auto',
      flex: 1,
    },
    slotUnavailable: {
      ...slotStyle,
      color: 'rgba(155,155,155,0.5)',
      border: '2px solid rgba(155,155,155,0.5)',
      textDecoration: 'line-through',
      backgroundColor: 'rgba(255,255,255,0.4)',
    },
    slotAvailable: {
      ...slotStyle,
      color: '#01372c',
      border: '2px solid #01372c',

      backgroundColor: 'rgba(255,255,255,0.4)',
      '& hover': {
        backgroundColor: 'rgb(84,84,84)',
      },
    },
    slotReserved: {
      ...slotStyle,
      color: '#ffffff',
      border: '2px solid #01372c',
      backgroundColor: '#01372c',
      '& hover': {
        backgroundColor: '#01372c !important',
      },
      '&.Mui-disabled': {
        backgroundColor: '#ccc',
      },
    },
    slider: {
      position: 'relative',
    },
    sliderNext: {
      ...sliderStyle,
      right: 0,
    },
    sliderPrevious: {
      ...sliderStyle,
      left: 0,
    },
    calendarBox: {
      textAlign: 'center',
      maxHeight: '100%',
      height: 'auto',
      boxShadow: '0 17px 12px -14px rgba(0,0,0,0.06)',
      borderBottom: '0 solid rgba(255,255,255,0)',
      display: 'flex',
      position: 'relative',
    },
    dayNumber: {
      fontSize: 14,
    },
    dayNameTile: {
      textAlign: 'center',
    },
    gridListWrapper: {
      border: '1px solid #01372c',
      borderRight: 0,
      borderTop: 0,
    },
    calendarTile: {
      border: '1px solid #01372c',
      borderBottom: 0,
      borderLeft: 0,
      width: 'auto',
      padding: '0 !important',
    },
    monthCard: {
      height: '100%',
      borderRadius: 0,
    },
    monthCardContent: {
      height: '100%',
      padding: 0,
    },
  });

  const classes = useStyles();

  const getSlotType = (status) => {
    switch (status) {
      case 'free':
        return classes.slotAvailable;
      case 'booked':
        return classes.slotReserved;
      default:
        return classes.slotUnavailable;
    }
  };

  return {
    classes,
    getSlotType,
  };
};

export default useCalendarStyles;
